import { render, staticRenderFns } from "./DefiMint.vue?vue&type=template&id=38452864&"
import script from "./DefiMint.vue?vue&type=script&lang=js&"
export * from "./DefiMint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports